// Import CSS
require("../sass/styles.scss");
require('./app');



/*****************
 ** WEBPACK FOOTER
 ** ./js/main.js
 ** module id = 0
 ** module chunks = 0
 **/